import e from "./highrise1458.mjs";
import o from "./highrise1459.mjs";
var t = Object.prototype, a = t.hasOwnProperty, n = t.propertyIsEnumerable, c = e(/* @__PURE__ */ function() {
  return arguments;
}()) ? e : function(r) {
  return o(r) && a.call(r, "callee") && !n.call(r, "callee");
};
export {
  c as default
};
